<template>
  <div>
    <div class="sp sp-2"> </div>

    <div id="e">
      <div class="sp sp-5"></div>

      <div id="about" class="v2-container">
        <div class="v2-skills">
          <ul class="v2-skills__list">
            <li class="v2-skills__list-item"
              >SPA with Vue.js + Vuex + Router</li
            >
            <li class="v2-skills__list-item">Laravel</li>
            <li class="v2-skills__list-item">REST API</li>
            <li class="v2-skills__list-item">Ajax, Axios, Json</li>
            <li class="v2-skills__list-item">HTML, CSS, JavaScript, jQuery</li>
            <li class="v2-skills__list-item">ES5/6</li>
            <li class="v2-skills__list-item">Sass/Scss</li>
            <li class="v2-skills__list-item">Bootstrap, Tailwind CSS</li>
            <li class="v2-skills__list-item">GSAP</li>
            <li class="v2-skills__list-item">Webpack, Gulp</li>
            <li class="v2-skills__list-item">Figma</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="sp sp-3" data-h-color="blck-5"></div>

    <div class="cirbc">
      <div class="ico"> </div>
      <svg viewBox="0 0 100 100">
        <defs>
          <linearGradient id="grd-av" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop data-color-c="l" offset="0%" stop-color="#00afb5" />
            <stop data-color-c="r" id="" offset="100%" stop-color="#22fcb0" />
          </linearGradient>
        </defs>
        <circle stroke="url(#grd-av)" cx="50" cy="50" r="48"></circle>
      </svg>
      <div class="cirb">
        <div class="cirbr"></div>
      </div>
      <div class="v2-skills-title">My skills</div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

import gsap from "gsap-3";
import ScrollTrigger from "gsap-3/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: "V2Skills",
  data() {
    return {
      elemTop: 0,
    };
  },
  mounted() {
    this.elemTop = $(".sp-2").offset().top; //get the offset top of the element

    this.init();
  },
  methods: {
    init() {
      var $win = $(window);

      this.sizeBgRound();

      var $tl2 = gsap.timeline({
        scrollTrigger: {
          trigger: ".sp-2",
          start: "bottom bottom",
          scrub: true,
        },
      });

      $tl2.to(
        ".cirbc svg",
        1,
        { rotation: 180, opacity: 1, strokeDasharray: "300 999" },
        "a"
      );
      $tl2.to(".cirbc .ico, .v2-skills-title", 1, { opacity: 1 }, "a");

      if ($win.width() < 768) {
        var $tl7 = gsap.timeline({
          scrollTrigger: {
            trigger: ".v2-skills",
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        });
        $tl7
          .to(".v2-skills-title", 0.25, { opacity: 0.3 }, "a")
          .to(".cirbc .ico, .cirbc svg", 0.25, { opacity: 0.1 }, "a");
      }

      var $tl3 = gsap.timeline({
        scrollTrigger: {
          trigger: ".sp-5",
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      });
      $tl3.to(".cirbc .cirbr", 1, { width: "100%", height: "100%" }, "a");
      // $tl3.to(".cir", 1, { scale: 0, opacity: 0 }, "a");

      var $tl5 = gsap.timeline({
        scrollTrigger: {
          trigger: ".sp-3",
          start: "top 50%",
          end: "bottom 50%",
          scrub: true,
        },
      });
      $tl5.to(".cirbc .cirbr", 1, { opacity: 0 }, "a");
      $tl5.to(".sp-2", 1, { opacity: 0 }, "a");
      $tl5.to(
        ".cirbc .ico, .v2-skills-title",
        0.7,
        { scale: 0, opacity: 0 },
        "a"
      );
      $tl5.to(".cirbc svg", 0.7, { scale: 0, opacity: 0 }, "a");

      var $tl6 = gsap.timeline({
        scrollTrigger: {
          trigger: ".sp-3",
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      });
      $tl6.to(".cirbc", 1, { zIndex: -1 }, "a");
    },
    sizeBgRound() {
      var $win = $(window);

      var $w_w = $win.width() * 1.5;
      var $w_h = $win.height() * 1.5;
      if ($w_w > $w_h) {
        $(".cirbc .cirb")
          .width($w_w)
          .height($w_w);
      } else {
        $(".cirbc .cirb")
          .width($w_h)
          .height($w_h);
      }
    },
  },
};
</script>
